import React from 'react'

export default function Tag({ children, ...props }) {
  return (
    <span
      {...props}
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-200 text-gray-800 ${
        props.className || ''
      }`}
    >
      {children}
    </span>
  )
}
